module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ari Sihvola","short_name":"Ari Sihvola","start_url":"https://arisihvola.fi","scope":"https://arisihvola.fi","icon":"src/images/favicon.png","legacy":true,"display":"browser"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
